import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "min-w-full divide-y divide-gray-blue-200 dark:divide-gray-bluer-400" }
const _hoisted_2 = {
  scope: "col",
  class: "px-4 py-5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
}
const _hoisted_3 = ["checked"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-4 py-5 text-left text-sm font-bold text-gray-bluer-200"
}, " File ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-4 py-5 text-left text-sm font-bold text-gray-bluer-200"
}, " Format ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-4 py-5 text-left text-sm font-bold text-gray-bluer-200"
}, " Upload Date ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-4 py-5 text-left text-sm font-bold text-gray-bluer-200"
}, " Size ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-4 py-5 text-left text-sm font-bold text-gray-bluer-200"
}, null, -1)
const _hoisted_9 = { class: "divide-y divide-gray-blue-200 dark:divide-gray-bluer-400" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "flex items-center" }
const _hoisted_12 = { class: "flex-shrink-0 h-10 w-10 text-gray-blue-500" }
const _hoisted_13 = { class: "inline-flex items-center justify-center bg-gray-blue-500 dark:bg-gray-bluer-400 rounded-sm w-10 h-10 text-xs font-bold text-gray-bluer-200 uppercase" }
const _hoisted_14 = { class: "ml-4" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm font-bold text-gray-bluer-300" }, [
  /*#__PURE__*/_createElementVNode("span", null, "...")
], -1)
const _hoisted_16 = { class: "text-xs text-gray-bluer-100 font-medium" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "flex items-center" }
const _hoisted_20 = { class: "flex-shrink-0 h-10 w-10 text-gray-blue-500" }
const _hoisted_21 = { class: "inline-flex items-center justify-center bg-gray-blue-500 dark:bg-gray-bluer-400 rounded-sm w-10 h-10 text-xs font-bold text-gray-bluer-200 uppercase" }
const _hoisted_22 = { class: "ml-4" }
const _hoisted_23 = { class: "text-sm font-bold text-gray-bluer-300" }
const _hoisted_24 = { class: "text-xs text-gray-bluer-100 font-medium" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { class: "flex items-center justify-end" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "px-4 py-5" }
const _hoisted_30 = ["checked", "onClick"]
const _hoisted_31 = { class: "px-4 py-5 whitespace-nowrap" }
const _hoisted_32 = { class: "flex items-center" }
const _hoisted_33 = { class: "flex-shrink-0 h-10 w-10" }
const _hoisted_34 = ["src", "alt"]
const _hoisted_35 = {
  key: 1,
  class: "inline-flex items-center justify-center bg-gray-blue-500 dark:bg-gray-bluer-400 rounded-sm w-10 h-10 text-xs font-bold text-gray-bluer-200 uppercase"
}
const _hoisted_36 = { class: "ml-4" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["href"]
const _hoisted_39 = { class: "px-4 py-5 whitespace-nowrap text-sm uppercase text-gray-bluer-200 font-medium" }
const _hoisted_40 = { class: "px-4 py-5 text-sm whitespace-nowrap text-gray-bluer-200 font-medium" }
const _hoisted_41 = { class: "px-4 py-5 whitespace-nowrap text-sm text-gray-bluer-200 font-medium" }
const _hoisted_42 = { class: "px-4 py-5 whitespace-nowrap text-left text-sm font-medium" }
const _hoisted_43 = { class: "flex justify-end items-center" }
const _hoisted_44 = { class: "flex justify-start space-x-2" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = ["onClick"]
const _hoisted_49 = ["onClick"]
const _hoisted_50 = ["onClick"]

import { useStore }       from "vuex";
import { load }           from "../mixin";
import { date, fileSize } from "@greywind/common";


export default /*#__PURE__*/_defineComponent({
  props: {
        searchAllMode: {
            type:     Boolean,
            default:  false,
            required: false
        },
    },
  emits: [ 'preview', 'download', 'replace' ],
  setup(__props, { emit }) {

const props = __props



const store = useStore();

const {
          backPath,
          searchResults,
          allFilesSelected,
          selectedFiles,
          mode,
          activeFile,
          filteredFiles,
          setPath,
          setAllFilesSelected,
          setSelectedFiles,
          setFile,
          setModal,
          deleteFolder,
          deleteFile,
          selectFile,
          toggleAllFilesSelection,
          toggleFileSelection
      } = load( store );



return (_ctx: any,_cache: any) => {
  const _component_x_icon = _resolveComponent("x-icon")!
  const _component_x_popper = _resolveComponent("x-popper")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("th", _hoisted_2, [
          _createElementVNode("input", {
            type: "checkbox",
            class: "focus:ring-theme-500 h-4 w-4 text-theme-600 border-gray-300 rounded dark:bg-gray-bluer-800 dark:border-gray-bluer-500",
            checked: _unref(allFilesSelected),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(toggleAllFilesSelection)( $event.target.checked )))
          }, null, 8, _hoisted_3)
        ]),
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _hoisted_8
      ])
    ]),
    _createElementVNode("tbody", _hoisted_9, [
      (_unref(backPath) && __props.searchAllMode === false)
        ? (_openBlock(), _createElementBlock("tr", _hoisted_10, [
            _createElementVNode("td", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(setPath)(_unref(backPath)))),
              class: "px-4 py-5 cursor-pointer"
            }),
            _createElementVNode("td", {
              colspan: "5",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(setPath)(_unref(backPath)))),
              class: "px-4 py-5 cursor-pointer whitespace-nowrap"
            }, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", _hoisted_13, [
                    _createVNode(_component_x_icon, {
                      icon: "fontawesome.folder",
                      class: "h-5 w-5"
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(backPath)), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredFiles), (file, index) => {
        return (_openBlock(), _createElementBlock("tr", { key: index }, [
          (file.type === 'folder')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("td", {
                  onClick: ($event: any) => (_unref(setPath)(file.path)),
                  class: "px-4 py-5 cursor-pointer"
                }, null, 8, _hoisted_17),
                _createElementVNode("td", {
                  onClick: ($event: any) => (_unref(setPath)(file.path)),
                  class: "px-4 py-5 cursor-pointer whitespace-nowrap"
                }, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("span", _hoisted_21, [
                        _createVNode(_component_x_icon, {
                          icon: "fontawesome.folder",
                          class: "h-5 w-5"
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("span", null, _toDisplayString(file.name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_24, _toDisplayString(file.path), 1)
                    ])
                  ])
                ], 8, _hoisted_18),
                _createElementVNode("td", {
                  onClick: ($event: any) => (_unref(setPath)(file.path)),
                  class: "cursor-pointer",
                  colspan: "3"
                }, null, 8, _hoisted_25),
                _createElementVNode("td", {
                  onClick: ($event: any) => (_unref(setPath)(file.path)),
                  class: "px-4 py-5 cursor-pointer whitespace-nowrap text-left text-sm font-medium"
                }, [
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(_component_x_popper, {
                      arrow: "",
                      hover: "",
                      content: "Delete"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          href: "#",
                          class: "inline-flex text-gray-300 hover:text-red-500",
                          onClick: _withModifiers(($event: any) => (_unref(deleteFolder)( file.path )), ["prevent"])
                        }, [
                          _createVNode(_component_x_icon, {
                            icon: "fontawesome.trash",
                            "fa-type": "fas",
                            class: "h-5 w-5"
                          })
                        ], 8, _hoisted_28)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ], 8, _hoisted_26)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("td", _hoisted_29, [
                  _createElementVNode("input", {
                    type: "checkbox",
                    class: "focus:ring-theme-500 h-4 w-4 text-theme-600 border-gray-300 rounded dark:bg-gray-bluer-800 dark:border-gray-bluer-500",
                    checked: _unref(selectedFiles).indexOf(file.id) !== -1,
                    onClick: ($event: any) => (_unref(toggleFileSelection)( file, $event.target.checked ))
                  }, null, 8, _hoisted_30)
                ]),
                _createElementVNode("td", _hoisted_31, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      (file.is_image)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "h-10 w-10 rounded-sm",
                            src: file.url,
                            alt: file.alt
                          }, null, 8, _hoisted_34))
                        : (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(file.file_name.split( '.' ).pop()), 1))
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      (_unref(store).state.media.previewsEnabled)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "text-sm font-bold text-gray-bluer-300 hover:text-theme transition duration-150 ease-in-out cursor-pointer",
                            onClick: _withModifiers(($event: any) => (emit( 'preview', file )), ["prevent"])
                          }, [
                            _createElementVNode("span", null, _toDisplayString(file.name || file.file_name), 1)
                          ], 8, _hoisted_37))
                        : _createCommentVNode("", true),
                      _createElementVNode("a", {
                        href: file.url,
                        target: "_blank",
                        class: "text-xs text-gray-bluer-100 font-medium hover:text-theme-500 transition duration-150 ease-in-out"
                      }, _toDisplayString(file.url), 9, _hoisted_38)
                    ])
                  ])
                ]),
                _createElementVNode("td", _hoisted_39, _toDisplayString(file.file_name.split( '.' ).pop()), 1),
                _createElementVNode("td", _hoisted_40, _toDisplayString(_unref(date)( file.created_at )), 1),
                _createElementVNode("td", _hoisted_41, _toDisplayString(_unref(fileSize)( file.size )), 1),
                _createElementVNode("td", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      (file.age_status)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                            _createVNode(_component_x_popper, {
                              arrow: "",
                              hover: "",
                              content: file.age_status.message
                            }, {
                              default: _withCtx(() => [
                                (file.age_status.status == 'expired')
                                  ? (_openBlock(), _createBlock(_component_x_icon, {
                                      key: 0,
                                      icon: "fontawesome.exclamation-triangle",
                                      "fa-type": "fas",
                                      class: "h-5 w-5",
                                      style: {"color":"red"}
                                    }))
                                  : (_openBlock(), _createBlock(_component_x_icon, {
                                      key: 1,
                                      icon: "fontawesome.exclamation-triangle",
                                      "fa-type": "fas",
                                      class: "h-5 w-5",
                                      style: {"color":"orange"}
                                    }))
                              ]),
                              _: 2
                            }, 1032, ["content"])
                          ]))
                        : _createCommentVNode("", true),
                      (_unref(store).state.media.previewsEnabled)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                            _createVNode(_component_x_popper, {
                              arrow: "",
                              hover: "",
                              content: "Preview"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("a", {
                                  href: "#",
                                  class: "text-gray-blue-900 transition duration-150 ease-in-out hover:text-theme-500",
                                  onClick: _withModifiers(($event: any) => (emit( 'preview', file )), ["prevent"])
                                }, [
                                  _createVNode(_component_x_icon, {
                                    icon: "fontawesome.eye",
                                    "fa-type": "fas",
                                    class: "h-5 w-5"
                                  })
                                ], 8, _hoisted_47)
                              ]),
                              _: 2
                            }, 1024)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", null, [
                        _createVNode(_component_x_popper, {
                          arrow: "",
                          hover: "",
                          content: "Download"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              href: "#",
                              class: "text-gray-blue-900 transition duration-150 ease-in-out hover:text-theme-500",
                              onClick: _withModifiers(($event: any) => (emit( 'download', file )), ["prevent"])
                            }, [
                              _createVNode(_component_x_icon, {
                                icon: "fontawesome.arrow-down-to-line",
                                "fa-type": "fas",
                                class: "h-5 w-5"
                              })
                            ], 8, _hoisted_48)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_x_popper, {
                          arrow: "",
                          hover: "",
                          content: "Replace"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              href: "#",
                              class: "text-gray-blue-900 transition duration-150 ease-in-out hover:text-theme-500",
                              onClick: _withModifiers(($event: any) => (emit( 'replace', file )), ["prevent"])
                            }, [
                              _createVNode(_component_x_icon, {
                                icon: "fontawesome.arrow-right-arrow-left",
                                "fa-type": "fas",
                                class: "h-5 w-5"
                              })
                            ], 8, _hoisted_49)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _createElementVNode("div", null, [
                        _createVNode(_component_x_popper, {
                          arrow: "",
                          hover: "",
                          content: "Delete"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              href: "#",
                              class: "text-gray-blue-900 transition duration-150 ease-in-out hover:text-red-500",
                              onClick: _withModifiers(($event: any) => (_unref(deleteFile)( file )), ["prevent"])
                            }, [
                              _createVNode(_component_x_icon, {
                                icon: "fontawesome.trash",
                                "fa-type": "fas",
                                class: "h-5 w-5"
                              })
                            ], 8, _hoisted_50)
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ])
                  ])
                ])
              ], 64))
        ]))
      }), 128))
    ])
  ]))
}
}

})